// src/locales/en/returnToVendor.js
export const returnToVendor = {
  // Page titles
  returnToVendors: 'Returns To Vendor',
  allReturnToVendors: 'All Returns To Vendor',
  createReturnToVendor: 'Create Return To Vendor',
  returnToVendorDetails: 'Return To Vendor Details',
  viewAndManageAllReturnToVendors: 'View and manage all returns to vendor',
  createReturnToVendorDescription: 'Return received items to a supplier against a goods received note',

  // List columns
  rtvNumber: 'RTV #',
  purchaseOrderNumber: 'Purchase Order',
  grnNumber: 'GRN #',
  supplier: 'Supplier',
  totalDebitAmount: 'Total Debit Amount',
  createdAt: 'Created At',
  createdBy: 'Created By',
  status: 'Status',
  actions: 'Actions',
  item: 'Item',
  warehouse: 'Warehouse',
  details: 'Return Details',
  itemsToReturn: 'Items to Return',
  itemsReturned: 'Items Returned',
  returnableQuantity: 'Returnable Qty',
  quantityReturned: 'Quantity Returned',
  unitPriceLabel: 'Unit Price',
  lineAmount: 'Line Amount',
  unitsSelected: 'units selected',
  linkedDebitNotes: 'Linked Debit Notes',

  // Status labels — used via t(`returnToVendor.status_${rtv.status}`)
  status_completed: 'Completed',
  status_voided: 'Voided',

  // Form fields
  lookupGoodsReceivedNote: 'Look Up Goods Received Note',
  goodsReceivedNoteIdPlaceholder: 'Enter GRN ID/number or purchase order ID/number',
  purchaseOrderIdPlaceholder: 'Enter purchase order ID or number',
  grnIdPlaceholder: 'Enter GRN ID or number',
  lookupButton: 'Look Up',
  selectGoodsReceivedNote: 'Select Goods Received Note',
  multipleGoodsReceivedNotesFound: 'Multiple GRNs found for this order — select one',
  goodsReceivedNoteNotFound: 'Goods received note not found',
  purchaseOrderNotFound: 'Purchase order not found',
  reason: 'Reason',
  reasonPlaceholder: 'Reason for the return (optional)',
  returnFromWarehouse: 'Return From Warehouse',
  selectWarehouse: 'Select Warehouse',

  // Actions
  create: 'Create Return To Vendor',
  save: 'Save',
  voidReturnToVendor: 'Void Return To Vendor',
  void: 'Void',
  print: 'Print',
  printReturnToVendor: 'Print Return To Vendor',
  backToReturnToVendors: 'Back to Returns To Vendor',

  // Confirmations
  confirmVoid: 'Are you sure you want to void this return to vendor? Stock will be restored and voiding this RTV will also cancel its linked Debit Note.',
  voidReason: 'Reason for Voiding',
  voidReasonPlaceholder: 'Enter reason for voiding (optional)...',

  // Filters
  filterByPurchaseOrder: 'Filter by Purchase Order',
  filterByGoodsReceivedNote: 'Filter by Goods Received Note',

  // Success / error messages
  rtvCreatedSuccessWithDebitNote: 'Return to vendor {rtvNumber} created — Debit Note {debitNoteNumber} issued automatically',
  rtvVoidedSuccessfully: 'Return to vendor voided successfully',
  failedToCreateReturnToVendor: 'Failed to create return to vendor',
  failedToLoadReturnToVendors: 'Failed to load returns to vendor',
  failedToLoadReturnToVendor: 'Failed to load return to vendor',
  failedToVoidReturnToVendor: 'Failed to void return to vendor',
  someFieldsRequired: 'Please fix the highlighted fields before submitting',

  // Validation
  goodsReceivedNoteRequired: 'Please look up a goods received note',
  atLeastOneItemRequired: 'Please select at least one item to return',
  unitPriceRequired: 'Please enter a unit price',
  warehouseRequired: 'Please select a warehouse',

  // Empty states
  noReturnToVendorsFound: 'No returns to vendor found',
  noReturnToVendorsYet: 'No returns to vendor yet.',
  noReturnToVendorsFoundDescription: 'No returns to vendor match your current filters',
  noReturnToVendorsYetDescription: 'Create your first return to vendor to send items back to a supplier.',
  createFirstReturnToVendor: 'Create First Return To Vendor',

  // Searchable GRN lookup
  searchGoodsReceivedNote: "Search by GRN or purchase order number...",
  noGoodsReceivedNotesFound: "No goods received notes found",
  goodsReceivedNoteCancelled: "Cannot return against a cancelled goods received note",
  allStatuses: "All Statuses",
  searchPlaceholder: "Search by RTV, PO or GRN number",
};
